<template>
  <div class="un_feedCarouselWrapper">
    <section class="un_feedCarousel">
      <!-- 흠 -->
      <div
        class="un_feedCarousel_inner"
        ref="sectionFeedCarousel"
        style="
          overflow-x: auto;
          scroll-snap-type: x mandatory;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none;
        "
        @scroll.stop="onScroll"
      >
        <template v-for="(image, index) in images" :key="index">
          <img
            class="un_feedCarousel_item"
            v-if="typeof image === 'string'"
            :src="image"
            v-auto-title
            alt="피드 이미지"
            style="scroll-snap-align: center"
          />
          <figure
            v-else
            class="un_feedCarousel_item __video"
            style="scroll-snap-align: center"
          >
            <img :src="image.thumbnailUrl" alt="피드 이미지" />
            <i class="el_icon_size_56"></i>
          </figure>
        </template>
      </div>
      <div class="un_feedCarousel_btnWRapper">
        <button @click.stop="addImageIndex(-1)"></button>
        <button @click.stop="addImageIndex(+1)"></button>
      </div>
    </section>
    <feed-carousel-indicator
      :images="images"
      :image-index="imageIndex"
    ></feed-carousel-indicator>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
interface Props {
  images: any[];
}

const props = defineProps<Props>();
const sectionFeedCarousel = ref<HTMLElement>(null as any);
let sectionFeedCarouselWidth = 0;
const imageIndex = ref(0);

const addImageIndex = (value: number) => {
  imageIndex.value = Math.max(
    0,
    Math.min(props.images.length - 1, imageIndex.value + value)
  );
  const width = sectionFeedCarousel.value.getBoundingClientRect().width;
  const x = imageIndex.value * width;
  sectionFeedCarousel.value.scrollTo({ left: x, behavior: "smooth" });
};

const onScroll = (e: Event) => {
  const div = e.target as HTMLDivElement;
  const currentIndex = Math.round(
    sectionFeedCarousel.value.scrollLeft / sectionFeedCarouselWidth
  );
  imageIndex.value = currentIndex;
};

onMounted(() => {
  sectionFeedCarouselWidth =
    sectionFeedCarousel.value.getBoundingClientRect().width;
});
</script>

<style scoped>
@import "@/assets/css/seo.css";
@import "@/assets/css/base.css";
</style>
